import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Bus: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m140 210h507.65v30h-507.65z' />
    <path d='m136.53 330h507.65v30h-507.65z' />
    <path d='m240 540h300v30h-300z' />
    <circle cx='270' cy='450' r='30' />
    <circle cx='510' cy='450' r='30' />
    <path d='m660 570h-30v-358.44c0-33.94-29.16-61.56-65-61.56h-350c-35.84 0-65 27.62-65 61.56v358.44h-30v-358.44c0-50.49 42.62-91.56 95-91.56h350c52.38 0 95 41.07 95 91.56z' />
    <path d='m225 660h-105v-100h30v70h75c8.27 0 15-6.73 15-15v-55h30v55c0 24.81-20.19 45-45 45z' />
    <path d='m660 660h-105c-24.81 0-45-20.19-45-45v-55h30v55c0 8.27 6.73 15 15 15h75v-70h30z' />
    <path d='m690 360v-150h30v120c0 16.57-13.43 30-30 30z' />
    <path d='m90 360v-150s-30 0-30 0v120c0 16.57 13.43 30 30 30z' />
  </IconBase>
));

Bus.displayName = 'Bus';

export default Bus;
